import { observer } from "mobx-react";
import { withWSErrorContainer } from "../../../WSUtils/withWSErrorContainer";
import { device } from "../../../WSUtils/constants/mediaQueries";

import React, { useContext } from "react";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";
import styled from "styled-components";
import { getItem } from "../NavMenu/getItem";
import { navItems } from "../NavMenu/navItems";
import { CvpMenu } from "../../../Components/Menu/CvpMenu";

const SideNavMenu: React.FC = withWSErrorContainer(
  observer(({}) => {
    const userInfo = useContext(UserInfoContext);
    return (
      <StyledSideNavMenu
        className="cvp-side-nav"
        model={navItems.map((item) => getItem(item, userInfo))}
      />
    );
  })
);
export default SideNavMenu;

export const StyledSideNavMenu = styled(CvpMenu)`
  &.cvp-side-nav {
    padding-top: 6rem;
    width: 100%;
    border: none;

    .p-menuitem-link {
      display: flex;
      flex-direction: column;
      row-gap: 0.5rem;

      .p-menuitem-icon {
        font-size: 1.2em;
      }
      .p-menuitem-text {
        font-size: 0.9em;
      }

      @media ${device.xl} {
        display: flex;
        flex-direction: row;
        padding: 1.3rem 1.1rem;

        .p-menuitem-text,
        .p-menuitem-icon {
          font-size: 1.05em;
        }
      }
    }

    .active {
      .p-menuitem-text,
      .p-menuitem-icon {
        font-weight: 700;
      }
    }
  }
`;
